import { render, staticRenderFns } from "./GamiForm.vue?vue&type=template&id=27f2e73e&scoped=true"
import script from "./GamiForm.vue?vue&type=script&lang=js"
export * from "./GamiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2e73e",
  null
  
)

export default component.exports